const data = {
   carousels: [
      {
         id: 1,
         image: 'https://m.media-amazon.com/images/I/B1DBWbloIpS._CLa%7C2140%2C2000%7C91y%2B4ymrM4L.png%7C0%2C0%2C2140%2C2000%2B0.0%2C0.0%2C2140.0%2C2000.0_AC_UL1500_.png',
         title: 'Artisan GelEfex Gel Nail Polish',
         description:
            'Extra thick gel doesn’t mean durable, sometimes it just means messy. Good thing this brush on gel is neither',
         link: 'google.com',
      },
      {
         id: 2,
         image: 'https://m.media-amazon.com/images/I/B1DBWbloIpS._CLa%7C2140%2C2000%7C91y%2B4ymrM4L.png%7C0%2C0%2C2140%2C2000%2B0.0%2C0.0%2C2140.0%2C2000.0_AC_UL1500_.png',
         title: 'Artisan Colored Acrylic Nail Powder | Professional Size - Green',
         description:
            ' It will wear wonderfully for summer and spring inspired 3D nail art designs and nail enhancements',
         link: 'google.com',
      },
      {
         id: 3,
         image: 'https://m.media-amazon.com/images/I/B1pDnrUmaHS._CLa%7C2140%2C2000%7C91qSQl4VrZL.png%7C0%2C0%2C2140%2C2000%2B0.0%2C0.0%2C2140.0%2C2000.0_AC_UL1500_.png',
         title: 'Glow in Dark Nail Pigment Powder | Pack #1',
         description:
            'Show up to shine with a set of 12 glow-in-the-dark color powder',
         link: 'google.com',
      },
   ],
   menuItems1: [
      { name: 'Nail Repair', price: '$5+' },
      { name: 'Shiny Buffing', price: '$8' },
      { name: 'Nail Take Off w/ service', price: '$10' },
      { name: 'French', price: '$10+' },

      { name: 'Polish Change on Hands', price: '$15' },
      { name: 'Polish Change on Feet', price: '$18' },
   ],
   menuItems2: [
      { name: 'Gel Polish Change on Feet', price: '$25' },
      { name: 'Gel Polish Change on Hands', price: '$22' },
      { name: 'Big Toe Acrylic', price: '$10' },
      { name: 'Toe Arcylics', price: '$15' },
      { name: 'Nail Take Off', price: '$15' },
   ],
   menuAddition: [
      { name: 'Moisturizing Mask', price: '  $8' },
      { name: 'French Polish', price: '$8+' },
      { name: 'Paraffin Wax', price: '$10 ' },
      { name: 'Design', price: '$7+' },
      { name: 'Callus Removal', price: '$10' },
      { name: 'Sea Salt-Sugar Scrub', price: '$8' },
      { name: 'Gel Polish', price: '$15' },
   ],
   menuChild: [
      { name: 'Children Manicure', price: '$15' },
      { name: 'Children Pedicure', price: '$20' },
      { name: 'Children Pedi & Mani', price: '$30' },
      { name: 'Children Nail Design', price: '$5+' },
      { name: 'Children Regular Color Change', price: '$10' },
   ],
   menuLash: [
      { name: 'Eyelash Individual', price: '$100' },
      { name: 'Eyelash Volume', price: '$150' },
   ],
   menuWax1: [
      { name: 'Eyebrows', price: '$12' },
      { name: 'Sideburn', price: '$15' },
      { name: 'Upper Lip', price: ' $9' },
      { name: 'Chin', price: ' $12' },
      { name: 'Full Face', price: '$40' },
      { name: 'Underarm', price: '$20' },
      { name: 'Half Arms', price: '$30' },
   ],
   menuWax2: [
      { name: 'Full Arms', price: '$45' },
      { name: 'Bikini', price: '$40' },
      { name: 'Chest', price: ' $40' },
      { name: 'Full Back', price: '$50' },
      { name: 'Half Legs ', price: '$40' },
      { name: 'Full Legs', price: '$60' },
      { name: 'Brazilian', price: '$55' },
   ],
};

export default data;
